import { defineComponent as _defineComponent } from 'vue'

const __default__ = {
  name: 'TextFieldWithSubmitButton',
  inheritAttrs: false,
  model: {
    prop: 'modelValue',
    event: 'update:modelValue',
  },
}

import { ref, watch } from 'vue';
import { NcTextField } from '@nextcloud/vue'


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    modelValue: { default: undefined },
    value: { default: undefined },
    hint: { default: undefined },
    flexContainerClasses: { default: () => ['flex-justify-left', 'flex-align-start'] },
    flexItemClasses: { default: () => ['flex-justify-left', 'flex-align-start'] },
    readonly: { type: Boolean, default: false }
  },
  emits: [
  'submit',
  'input',
  'update:modelValue',
  'update:model-value',
  'update:value',
],
  setup(__props: any, { emit }) {

const props = __props as { modelValue: string|number, value: string|number, hint: string, flexContainerClasses: string[], flexItemClasses: string[], readonly: boolean };





// Keep a private data of the copy in order to support even missing
// value or modelValue props. Still hitting the submit button should
// present the current input value as event data.
const model = ref<string|number|undefined>(props.modelValue || props.value || '')

watch(() => props.value, (value) => { model.value = value })
watch(() => props.modelValue, (value) => { model.value = value })

watch(model, (value) => {
  emit('update:modelValue', value)
  emit('update:model-value', value)
  emit('update:value', value)
  emit('input', value)
})

return { __sfc: true,props, emit, model, NcTextField }
}

})